export default __webpack_public_path__ + "static/media/authorizedIcon.633b51c4.svg";